import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Tempotravellerhireinpune() {



  const cardData = {
"keyword": "Tempo Traveller Hire in Pune",

"headingDescription":
  "Aaradhya Travels offers reliable Tempo Traveller Hire in Pune for family trips, corporate travel, weddings, pilgrimage tours, airport transfers, and outstation journeys. Our well-maintained fleet includes 9, 12, 14, 17, 20, and 26-seater tempo travellers with AC, pushback seats, spacious interiors, and experienced drivers. We ensure safe, comfortable, and affordable group travel across Pune and Maharashtra with flexible booking options and 24/7 support.",

"topPlaces": [
{
"title": "Matheran",
"description":
"Matheran is Asia’s only automobile-free hill station known for viewpoints, toy train rides, and lush greenery. It is ideal for peaceful group trips from Pune."
},
{
"title": "Karnala Bird Sanctuary",
"description":
"Karnala Bird Sanctuary is a protected forest area near Mumbai known for trekking, birdwatching, and nature trails. It is ideal for adventure group trips from Pune."
},
  {
"title": "Ellora Caves",
"description":
"Ellora Caves is a UNESCO World Heritage site near Aurangabad famous for rock-cut temples, sculptures, and ancient Indian architecture. It is a popular long-distance group travel destination from Pune for history and heritage tours."
},
{
"title": "Ajanta Caves",
"description":
"Ajanta Caves are UNESCO-listed Buddhist caves known for ancient paintings, carvings, and historical significance. It is a top cultural and heritage group tour destination from Pune."
},

{
"title": "Harihareshwar",
"description":
"Harihareshwar is a coastal pilgrimage and beach destination known as 'Dakshin Kashi'. It is popular for temple visits, beaches, and group tours from Pune."
},
{
"title": "Diveagar",
"description":
"Diveagar is a clean and less crowded beach destination known for coconut trees, calm waters, and peaceful group outings from Pune."
},
{
"title": "Bhandardara",
"description":
"Bhandardara is a scenic hill station known for Arthur Lake, Randha Falls, and beautiful monsoon views. It is a popular weekend group trip destination from Pune."
},
{
"title": "Amboli",
"description":
"Amboli is a hill station in the Sahyadri range famous for waterfalls, mist, and green valleys. It is ideal for nature and monsoon group tours from Pune."
},
{
"title": "Chiplun",
"description":
"Chiplun is a scenic Konkan town surrounded by rivers, greenery, and ghats. It is a popular long-road group travel destination from Pune."
},
{
"title": "Lavasa",
"description":
"Lavasa is a planned hill city known for lakeside promenade, colorful architecture, cafes, and leisure activities. It is a popular short group trip destination from Pune."
},

],



services: [
  {
    name: "14 Seater Tempo Traveller Hire in Pune",
    description: "14 seater Tempo Traveller hire in Pune service provides comfortable transportation for family tours, airport transfers, wedding travel, sightseeing trips, and outstation journeys. Spacious seating and luggage space ensure smooth travel experiences suitable for medium-sized passenger groups. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient 14 seater traveller reservations."
  },
  {
    name: "17 Seater Tempo Traveller on Rent in Pimpri Chinchwad",
    description: "17 seater Tempo Traveller on rent in Pimpri Chinchwad service offers spacious transportation for family vacations, corporate outings, pilgrimage travel, and tourist journeys from Pimpri Chinchwad Pune. Comfortable pushback seating and smooth highway performance ensure pleasant travel experiences suitable for larger passenger groups. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, offices, hotels, and commercial areas across Pimpri Chinchwad Pune. Flexible booking options allow convenient 17 seater traveller reservations."
  },
  {
    name: "Tempo Traveller on Rent Near Me",
    description: "Tempo Traveller on rent near me service provides quick and reliable transportation for airport transfers, sightseeing tours, office outings, wedding travel, and outstation journeys. Spacious seating and comfortable interiors ensure smooth travel experiences suitable for all passenger groups. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient nearby traveller reservations."
  },
  {
    name: "20 Seater Tempo Traveller on Rent in Pune",
    description: "20 seater Tempo Traveller on rent in Pune service offers spacious transportation for educational tours, family functions, corporate events, airport transfers, and tourist travel. Comfortable seating and luggage capacity ensure smooth highway journeys suitable for medium and large passenger groups. Professional drivers ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient 20 seater traveller reservations."
  },
  {
    name: "25 Seater Tempo Traveller on Rent in Pune",
    description: "25 seater Tempo Traveller on rent in Pune service provides dependable transportation for wedding functions, pilgrimage tours, office outings, sightseeing trips, and family vacations. Spacious interiors and comfortable seating ensure pleasant travel experiences suitable for larger group travel requirements. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient 25 seater traveller reservations."
  },
  {
    name: "32 Seater Tempo Traveller on Rent in Pune",
    description: "32 seater Tempo Traveller on rent in Pune service offers comfortable transportation for educational tours, corporate travel, family functions, airport transfers, and outstation journeys. Spacious seating and smooth highway performance ensure reliable travel experiences suitable for large passenger groups. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient 32 seater traveller reservations."
  },
  {
    name: "Pune to Shirdi Tempo Traveller on Rent",
    description: "Pune to Shirdi Tempo Traveller on rent service provides reliable transportation for Sai Baba darshan tours, pilgrimage journeys, family trips, and spiritual group travel from Pune. Spacious seating and smooth highway travel ensure pleasant journeys suitable for devotees and senior citizens. Professional chauffeurs ensure safe driving and dependable transportation services throughout the Shirdi route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Shirdi traveller reservations."
  },
  {
    name: "Pune to Mahabaleshwar Tempo Traveller on Rent",
    description: "Pune to Mahabaleshwar Tempo Traveller on rent service offers comfortable hill station transportation for sightseeing tours, family vacations, office outings, and weekend trips from Pune. Spacious interiors and smooth ghat road travel ensure pleasant journeys suitable for tourist and family groups. Professional drivers ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Mahabaleshwar traveller reservations."
  },
  {
    name: "Pune to Ajanta Ellora Tempo Traveller on Rent",
    description: "Pune to Ajanta Ellora Tempo Traveller on rent service provides premium transportation for heritage tourism, educational tours, sightseeing journeys, and family vacations from Pune. Comfortable seating and spacious interiors ensure smooth long-distance travel experiences suitable for tourist groups. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Ajanta Ellora traveller reservations."
  },
  {
    name: "Pune to Solapur Tempo Traveller on Rent",
    description: "Pune to Solapur Tempo Traveller on rent service offers dependable transportation for business travel, pilgrimage journeys, educational tours, and family trips from Pune. Spacious seating and luggage space ensure comfortable highway travel suitable for all passenger groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Solapur traveller reservations."
  },
  {
    name: "Pune to Kolhapur Darshan Tempo Traveller on Rent",
    description: "Pune to Kolhapur darshan Tempo Traveller on rent service provides comfortable transportation for Mahalaxmi temple visits, sightseeing tours, pilgrimage journeys, and family vacations from Pune. Spacious interiors and smooth highway performance ensure pleasant travel experiences suitable for devotees and tourist groups. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Kolhapur traveller reservations."
  },
  {
    name: "Pune to Goa Tempo Traveller on Rent",
    description: "Pune to Goa Tempo Traveller on rent service offers premium long-distance transportation for beach vacations, sightseeing tours, bachelor trips, and family holidays from Pune. Spacious seating and luggage capacity ensure smooth highway journeys suitable for tourist and group travel requirements. Professional drivers ensure safe transportation and reliable pickup services throughout the Goa route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Goa traveller reservations."
  },
  {
    name: "Pune to Per KM Tempo Traveller on Rent",
    description: "Pune to per km Tempo Traveller on rent service provides flexible and affordable transportation for local travel, airport transfers, business trips, sightseeing journeys, and outstation tours. Spacious seating and comfortable interiors ensure smooth travel experiences suitable for all passenger groups. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient per km traveller reservations."
  },
  {
    name: "Tempo Traveller for Wedding Pune",
    description: "Tempo Traveller for wedding Pune service offers luxurious transportation for bridal parties, family members, wedding guests, and marriage event travel requirements. Spacious seating and elegant interiors ensure smooth travel experiences suitable for wedding ceremonies and celebrations. Professional drivers ensure punctual pickup and dependable transportation services throughout the wedding schedule. Pickup services are available from homes, banquet halls, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient wedding traveller reservations."
  },
  {
    name: "Tempo Traveller for Corporate Travel Pune",
    description: "Tempo Traveller for corporate travel Pune service provides professional transportation for employee travel, business meetings, conferences, industrial visits, and office outings. Spacious interiors and smooth travel performance ensure comfortable journeys suitable for office teams and executive passengers. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from IT parks, offices, hotels, airports, and commercial locations across Pune. Flexible booking options allow convenient corporate traveller reservations."
  },
  {
    name: "Tempo Traveller for Airport Pickup Pune",
    description: "Tempo Traveller for airport pickup Pune service offers dependable transportation for tourists, business travelers, wedding groups, and family passengers arriving at airport terminals. Spacious seating and luggage capacity ensure comfortable airport journeys suitable for all passenger groups. Professional drivers ensure timely airport pickups and safe transportation services throughout the route. Pickup services are available directly from airport terminals with flexible scheduling options. Convenient booking options allow hassle-free airport traveller reservations."
  },
  {
    name: "Tempo Traveller for Family Trip Pune",
    description: "Tempo Traveller for family trip Pune service provides comfortable transportation for holiday vacations, sightseeing journeys, pilgrimage travel, and group tours with relatives and family members. Spacious seating and luggage space ensure smooth travel experiences suitable for local and outstation family trips. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, railway stations, airports, and residential areas across Pune. Flexible booking options allow convenient family trip traveller reservations."
  },
  {
    name: "Tempo Traveller for Group Tour Pune",
    description: "Tempo Traveller for group tour Pune service offers spacious transportation for educational tours, sightseeing journeys, tourist travel, office outings, and pilgrimage tours. Comfortable interiors and smooth highway performance ensure pleasant travel experiences suitable for all passenger groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient group tour traveller reservations."
  },
  {
    name: "Luxury Tempo Traveller Pune",
    description: "Luxury Tempo Traveller Pune service provides premium transportation for weddings, corporate events, family vacations, airport transfers, and outstation journeys. Spacious luxury seating and modern interiors ensure smooth travel experiences suitable for executive passengers and tourist groups. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient luxury traveller reservations."
  },
  {
    name: "AC Tempo Traveller Pune",
    description: "AC Tempo Traveller Pune service offers premium air-conditioned transportation for sightseeing tours, family travel, business trips, airport transfers, and long-distance journeys. Comfortable seating and cooling systems ensure pleasant travel experiences suitable for all weather conditions. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient AC traveller reservations."
  },
  {
    name: "Outstation Tempo Traveller Pune",
    description: "Outstation Tempo Traveller Pune service provides reliable long-distance transportation for Goa tours, Mahabaleshwar trips, Konkan Darshan, pilgrimage journeys, and family vacations from Pune. Spacious seating and luggage capacity ensure comfortable highway travel suitable for tourist and business groups. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient outstation traveller reservations."
  }
],

tableData: [
  ["14 Seater Tempo Traveller Hire in Pune", "17 Seater Tempo Traveller on Rent in Pimpri Chinchwad"],
  ["Tempo Traveller on Rent Near Me", "20 Seater Tempo Traveller on Rent in Pune"],
  ["25 Seater Tempo Traveller on Rent in Pune", "32 Seater Tempo Traveller on Rent in Pune"],
  ["Pune to Shirdi Tempo Traveller on Rent", "Pune to Mahabaleshwar Tempo Traveller on Rent"],
  ["Pune to Ajanta Ellora Tempo Traveller on Rent", "Pune to Solapur Tempo Traveller on Rent"],
  ["Pune to Kolhapur Darshan Tempo Traveller on Rent", "Pune to Goa Tempo Traveller on Rent"],
  ["Pune to Per KM Tempo Traveller on Rent", "Tempo Traveller for Wedding Pune"],
  ["Tempo Traveller for Corporate Travel Pune", "Tempo Traveller for Airport Pickup Pune"],
  ["Tempo Traveller for Family Trip Pune", "Tempo Traveller for Group Tour Pune"],
  ["Luxury Tempo Traveller Pune", "AC Tempo Traveller Pune"],
  ["Outstation Tempo Traveller Pune", "14 Seater Tempo Traveller Hire in Pune"]
],



 whychoose: [
      {
        WhyChooseheading: "Reliable Tempo Traveller Hire in Pune",
        WhyChoosedescription: "Aaradhya Travels provides reliable Tempo Traveller hire service in Pune with comfortable vehicles, professional drivers, and smooth travel arrangements for family tours, corporate trips, and group travel."
      },
      {
        WhyChooseheading: "Affordable Tempo Traveller Hire Packages",
        WhyChoosedescription: "Aaradhya Travels offers affordable Tempo Traveller hire in Pune with transparent pricing, flexible booking plans, and complete travel support without hidden charges."
      },
      {
        WhyChooseheading: "24/7 Tempo Traveller Booking Service",
        WhyChoosedescription: "Our Tempo Traveller hire service in Pune operates 24 hours for airport transfers, weddings, corporate outings, pilgrimage tours, weekend trips, and outstation travel."
      },
      {
        WhyChooseheading: "Comfortable & Fully AC Tempo Travellers",
        WhyChoosedescription: "All Tempo Travellers provided by Aaradhya Travels are spacious, air-conditioned, clean, and regularly maintained for safe and comfortable group travel experiences."
      },
      {
        WhyChooseheading: "One Day & Multi-Day Tour Packages",
        WhyChoosedescription: "Aaradhya Travels offers customized one-day tours, weekend trips, multi-day outstation journeys, and flexible travel packages according to customer travel requirements."
      },
      {
        WhyChooseheading: "13, 17 & 20 Seater Tempo Traveller Options",
        WhyChoosedescription: "Customers can choose from 13 seater, 17 seater, and 20 seater Tempo Travellers suitable for family vacations, office teams, wedding groups, tourists, and pilgrimage travel."
      },
      {
        WhyChooseheading: "Pickup Available Across Pune City",
        WhyChoosedescription: "Aaradhya Travels provides doorstep pickup from Pune Airport, railway stations, hotels, homes, and major Pune locations including Baner, Wakad, Hinjewadi, Kharadi, Pimpri, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Safe Highway Travel",
        WhyChoosedescription: "Our experienced drivers ensure safe driving, smooth highway journeys, and timely travel for local sightseeing and outstation transportation requirements."
      }
    ]
  };

  const faqData = [
    { question: "What is Tempo Traveller hire in Pune?", answer: "Tempo Traveller hire service in Pune provides comfortable group transportation for family trips, corporate travel, weddings, and outstation tours." },
    { question: "Is Tempo Traveller booking available 24 hours in Pune?", answer: "Yes, Aaradhya Travels provides 24/7 Tempo Traveller hire service in Pune." },
    { question: "Which Tempo Traveller seating options are available?", answer: "Aaradhya Travels offers 13 seater, 17 seater, and 20 seater Tempo Travellers for different group travel requirements." },
    { question: "Can I book Tempo Traveller for outstation travel?", answer: "Yes, customers can book Tempo Travellers for outstation tours, hill station trips, pilgrimage journeys, and holiday travel." },
    { question: "Do you provide Tempo Travellers for corporate events?", answer: "Yes, Aaradhya Travels provides Tempo Traveller hire service for corporate meetings, office outings, conferences, and employee transportation." },
    { question: "Are all Tempo Travellers air-conditioned?", answer: "Yes, all Tempo Travellers are fully air-conditioned and maintained for comfortable group travel." },
    { question: "Can I book Tempo Traveller online in Pune?", answer: "Yes, customers can easily book Tempo Traveller hire service online or through phone booking." },
    { question: "Do you provide Tempo Travellers for weddings and family tours?", answer: "Yes, Aaradhya Travels provides spacious Tempo Travellers suitable for weddings, family vacations, and group tours." },
    { question: "Are Tempo Traveller hire charges transparent?", answer: "Yes, Aaradhya Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Tempo Traveller hire service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, wedding seasons, and peak travel periods." }
  ];

 const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Deshmukh",
    feedback:
      "Group travel across Pune became very convenient with Aaradhya Travels providing a Tempo Traveller for our journey. The vehicle was well-maintained, and the entire trip felt comfortable and well coordinated.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Kulkarni",
    feedback:
      "Aaradhya Travels arranged a Tempo Traveller hire in Pune for our family outing, and the experience was very smooth. Everyone could travel together comfortably, and the service was reliable throughout.",
    rating: 5
  }
];





  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Mahabaleshwar Tempo Traveller", link: "Pune-to-Mahabaleshwar-Tempo-Traveller" },
    { place: "/images/keyword/3.jpg", text: "Pune to Outstation Tempo Traveller", link: "Pune-to-Outstation-Tempo-Traveller" },
    { place: "/images/keyword/4.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Mini Bus on Rent Pune", link: "Outstation-Mini-Bus-on-Rent-Pune" },
    { place: "/images/keyword/6.jpg", text: "14 Seater Tempo Traveller on Rent in Pune", link: "14-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "17 Seater Bus on Rent in Pune", link: "17-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Tempo Traveller", link: "Pune-to-Shirdi-Tempo-Traveller" },
    { place: "/images/keyword/9.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/10.jpg", text: "25 Seater Tempo Traveller on Rent in Pune", link: "25-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/11.jpg", text: "Tempo Traveller on Rent in Pimpri Chinchwad", link: "Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" },
    { place: "/images/keyword/12.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
    { place: "/images/keyword/13.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/14.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/15.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/16.jpg", text: "Non AC Bus Rental Service in Pune", link: "Non-AC-Bus-Rental-Service-in-Pune" },
    { place: "/images/keyword/17.jpg", text: "Luxury Bus Rental in Pune", link: "Luxury-Bus-Rental-in-Pune" },
    { place: "/images/keyword/18.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "Luxury-Force-Urbania-On-Rent-in-Pune" },
    { place: "/images/keyword/19.jpg", text: "Force Urbania Luxury Mini Bus On Rent", link: "Force-Urbania-Luxury-Mini-Bus-On-Rent" },
    { place: "/images/keyword/20.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune-2" },
    { place: "/images/keyword/21.jpg", text: "14 17 20 25 Seater Bus on Rent in Pune", link: "14-17-20-25-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/22.jpg", text: "Travel Agents in Pune for Mini Bus Hire", link: "Travel-Agents-in-Pune-for-Mini-Bus-Hire" },
    { place: "/images/keyword/23.jpg", text: "Tempo Traveller Hire in Pune", link: "Tempo-Traveller-Hire-in-Pune" },
  ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Tempo Traveller Hire in Pune",
  "image": "https://www.aaradhyatravels99.com/assets/images/tempo-traveller-hire-in-pune.jpg",
  "description": "Book Tempo Traveller Hire in Pune with Aaradhya Travels for family trips, corporate travel, weddings, airport transfers, and outstation journeys. Available in 14, 17, 20, 25, and 32 seater options for Shirdi, Mahabaleshwar, Goa, Mumbai, and Maharashtra tours.",
  "brand": {
    "@type": "Brand",
    "name": "Aaradhya Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "3854"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://www.aaradhyatravels99.com/tempo-traveller-hire-in-pune"
  }
};




  return (
    <div>
<Helmet>
  <title>
    Tempo Traveller Hire in Pune | 14 to 32 Seater Rental | +91 9529697070
  </title>

  <meta
    name="description"
    content="Hire Tempo Traveller in Pune with Aaradhya Travels. Affordable 14, 17, 20, 25, and 32 seater tempo travellers available for Shirdi trips, corporate tours, weddings, airport transfers, and outstation travel across Maharashtra."
  />

  <meta
    name="keywords"
    content="14 Seater Tempo Traveller Hire in Pune, 17 Seater Tempo Traveller on rent in Pimpri Chinchwad, Tempo Traveller on rent near me, 20 Seater Tempo Traveller on rent in Pune, 25 Seater Tempo Traveller on rent in Pune, 32 Seater Tempo Traveller on rent in Pune, Pune to Shirdi Tempo Traveller on Rent"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/23.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#FFB100', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Aaradhya Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaradhya Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaradhya Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529697070" className="pc-call">+91 9529697070</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529697070"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529697070" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@aaradhyatravels99.com" className="pc-email">
                      booking@aaradhyatravels99.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aaradhya Travels</strong><br />
                      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Tempotravellerhireinpune;